<div
  class="modal fade"
  [id]="modalId"
  tabindex="-1"
  aria-labelledby="reportTypeSelectorLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-success text-white">
        <h5 class="modal-title" id="reportTypeSelectorLabel">
          <i class="fa-solid fa-file-alt me-2"></i>
          Selecione o Tipo de Relatório
        </h5>
        <button
          type="button"
          class="btn-close btn-close-white"
          (click)="closeModal()"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body p-4">
        <label for="reportTypeSelect" class="form-label">Tipo de Relatório</label>
        <select 
          id="reportTypeSelect" 
          class="form-select form-select-lg" 
          [(ngModel)]="selectedTypeId"
          (change)="onTypeChange()"
        >
          <option value="" disabled>Selecione o tipo de relatório</option>
          <option *ngFor="let type of reportTypes" [value]="type.id">
            {{ type.name }}
          </option>
        </select>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="closeModal()"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
